import Circle from '../../../assets/images/circle.png';
import { Progress } from 'antd';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { Wallet } from '../../../interfaces';
import { priceDigit } from 'scripts';
import { Button } from '30pay/components';
import { useNavigate } from 'react-router-dom';

interface Props {
    wallet?: Wallet;
    hideBalances: boolean;
    setHideBalances: Dispatch<SetStateAction<boolean>>;
}

export const WalletSummary: FC<Props> = (props) => {
    const navigate = useNavigate()
    const HIDDEN = '****';

    const handleToggleHideBalances = () => props.setHideBalances(!props.hideBalances);

    const [percentages, setPercentages] = useState<{ irt: number; crypto: number }>({ irt: 0, crypto: 0 });

    const handleProgress = () => {
        if (props.wallet) {
            const cryptoDollarValue = props.wallet?.assets
                .filter((asset) => asset.symbol?.toUpperCase() !== 'IRT')
                .reduce((acc, asset) => acc + asset.balance * asset.lastPrice, 0);

            const irtDollarValue = props.wallet?.usdtBalance - cryptoDollarValue;

            const usdtBalance = props.wallet.usdtBalance || 0.01;

            const irtPercent = (irtDollarValue / usdtBalance) * 100;
            const cryptoPercent = (cryptoDollarValue / usdtBalance) * 100;

            setPercentages({
                irt: irtPercent ?? 0,
                crypto: cryptoPercent ?? 0,
            });
        }
    };

    useEffect(() => {
        handleProgress();
    }, [props.wallet]);

    return (
        <div className="rounded-lg overflow-hidden w-full p-6 bg-primary-100 flex max-lg:flex-col justify-between items-center relative">
            <div className='flex items-center gap-6 max-lg:self-start'>
                <img className="absolute right-1/2 w-full opacity-10 object-cover" src={Circle} alt="circle" />
                <Progress
                    showInfo={false}
                    type="circle"
                    percent={percentages.irt}
                    strokeColor="#40DD7F"
                    strokeWidth={16}
                    trailColor="#ffffff"
                />
                <div className="flex flex-col text-white">
                    <div className="flex items-center mb-[10px] gap-2 z-20">
                        <h6 className={'max-lg:text-xs'}>موجودی کل دارایی‌ها</h6>
                        <div onClick={handleToggleHideBalances} className="cursor-pointer">
                            {props.hideBalances ? <IoEyeOffOutline /> : <IoEyeOutline />}
                        </div>
                    </div>
                    <h5 className="flex items-center gap-2 text-3xl max-lg:text-xl">
                        {props.hideBalances ? HIDDEN : priceDigit(props?.wallet?.irtBalance?.toFixed(0))}
                        <label className="text-base font-bold max-lg:text-xs en">تومان</label>
                    </h5>
                    <div className="flex items-center gap-2 font-bold">
                        <span className="text-xl font-bold max-lg:text-base">
                            {props.hideBalances ? HIDDEN : props?.wallet?.usdtBalance?.toLocaleString()}
                        </span>
                        <label className="text-sm font-bold max-lg:text-xs en">USDT</label>
                    </div>
                    <div className="mt-1 flex items-center gap-6">
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 rounded-[3px] bg-positive-light max-lg:w-2 max-lg:h-2" />
                            <p className="font-medium text-sm max-lg:text-[10px]">موجودی تومانی</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="w-3 h-3 rounded-[3px] bg-white max-lg:w-2 max-lg:h-2" />
                            <p className="font-medium text-sm max-lg:text-[10px]">موجودی ارزی</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex flex-col gap-3 self-start max-lg:flex-row max-lg:w-full max-lg:mt-6'>
                <Button
                    className={'!h-8 text-sm max-lg:w-full'}
                    onClick={() => navigate('/wallet/deposit')}
                >
                    واریز
                </Button>
                <Button
                    className={'!h-8 text-sm max-lg:w-full'}
                    onClick={() => navigate('/wallet/withdrawal')}
                >
                    برداشت
                </Button>
            </div>
        </div>
    );
};
